import { createBrowserRouter, Navigate } from "react-router-dom";

import { solicitudesRoutes } from "@features/Solicitudes";
import { solicitudRoutes } from "@features/Solicitud/routes/solicitud";
import { loginRoutes } from "@features/Autenticacion/routes/login";
import { adminRoutes } from "@features/Administracion/routes/admin";
import { dashboardsRoutes } from "@features/Dashboards/routes/dashboards";
import { reporteriaRoutes } from "@features/Reporteria/routes/reporteria";

const router = createBrowserRouter([
    dashboardsRoutes,
    solicitudesRoutes,
    solicitudRoutes,
    adminRoutes,
    reporteriaRoutes,
    loginRoutes,
    {
        path: "*",
        element: <Navigate to="/" replace />,
    },
]);

export default router;
